import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'

const _BASE_URL = import.meta.env.REACT_APP_IAM_API_BASE_URL

export interface LanguageConfigItem {
  id: string
  displayName: string
  displayShortName: string
}

export const globalConfigsApi = createApi({
  reducerPath: 'globalConfigsApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  endpoints: (builder) => ({
    getLanguages: builder.query<{ data: LanguageConfigItem[] }, { includeBeta?: boolean } | undefined>({
      query: (params) => ({ url: '/global-configs/languages', params }),
    }),
  }),
})

export const { useGetLanguagesQuery } = globalConfigsApi
